import type { BaseIconProps } from "@/assets/icons/utils";
import type { FC } from "react";

export const IconPanelRightClose: FC<BaseIconProps> = ({ size, className }) => {
    switch (size) {
        case "sm":
            return (
                <svg
                    className={className}
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M9.74976 2.74988V13.2499M5.66642 6.24988L7.41642 7.99988L5.66642 9.74988M3.91642 2.74988H12.0831C12.7274 2.74988 13.2498 3.27221 13.2498 3.91654V12.0832C13.2498 12.7275 12.7274 13.2499 12.0831 13.2499H3.91642C3.27209 13.2499 2.74976 12.7275 2.74976 12.0832V3.91654C2.74976 3.27221 3.27209 2.74988 3.91642 2.74988Z"
                        stroke="currentColor"
                        strokeWidth="1.2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            );
        case "base":
            return (
                <svg
                    className={className}
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M12.2498 3.24982V16.7498M6.99976 7.74982L9.24976 9.99982L6.99976 12.2498M4.74976 3.24982H15.2498C16.0782 3.24982 16.7498 3.92139 16.7498 4.74982V15.2498C16.7498 16.0782 16.0782 16.7498 15.2498 16.7498H4.74976C3.92133 16.7498 3.24976 16.0782 3.24976 15.2498V4.74982C3.24976 3.92139 3.92133 3.24982 4.74976 3.24982Z"
                        stroke="currentColor"
                        strokeWidth="1.2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            );
        case "lg":
            return (
                <svg
                    className={className}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M14.5 4.5V19.5M8.66667 9.5L11.1667 12L8.66667 14.5M6.16667 4.5H17.8333C18.7538 4.5 19.5 5.24619 19.5 6.16667V17.8333C19.5 18.7538 18.7538 19.5 17.8333 19.5H6.16667C5.24619 19.5 4.5 18.7538 4.5 17.8333V6.16667C4.5 5.24619 5.24619 4.5 6.16667 4.5Z"
                        stroke="currentColor"
                        strokeWidth="1.25"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                    />
                </svg>
            );
    }
};
